import { style, styleVariants } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const buttonBase = style({
  position: "relative",
  paddingTop: primitiveTokens.sizing["0x"],
  paddingBottom: primitiveTokens.sizing["0x"],
  paddingLeft: primitiveTokens.sizing["4x"],
  paddingRight: primitiveTokens.sizing["4x"],
  cursor: "pointer",
  borderRadius: primitiveTokens.radii.sm,
  borderWidth: primitiveTokens.strokes.md,
  borderStyle: "solid",
  borderColor: "transparent",
  lineHeight: "normal",
  fontWeight: 500,
  transition:
    "background-color 120ms ease, box-shadow 120ms ease, border-color 120ms ease",
  selectors: {
    "&:focus-visible": {
      boxShadow: primitiveTokens.colors.shadow.focusRing,
      outline: "none"
    },
    "&:disabled": {
      cursor: "default"
    }
  }
});

export const buttonSizes = styleVariants({
  lg: {
    fontSize: primitiveTokens.type.lg,
    height: primitiveTokens.sizing["12x"]
  },
  md: {
    fontSize: primitiveTokens.type.md,
    height: primitiveTokens.sizing["10x"]
  },
  sm: {
    fontSize: primitiveTokens.type.sm,
    height: primitiveTokens.sizing["9x"]
  },
  xs: {
    fontSize: primitiveTokens.type.xs,
    height: primitiveTokens.sizing["8x"]
  }
});

export const buttonPrimary = {
  backgroundColor: semanticThemeTokens.button.primary.default.backgroundColor,
  color: semanticThemeTokens.button.primary.textColor,
  borderColor: "transparent",
  outline: "none",
  selectors: {
    "&:focus-visible": {
      backgroundColor: semanticThemeTokens.button.primary.focus.backgroundColor
    },
    "&:hover": {
      backgroundColor: semanticThemeTokens.button.primary.hover.backgroundColor
    },
    "&:active": {
      backgroundColor: semanticThemeTokens.button.primary.active.backgroundColor
    },
    "&:disabled": {
      backgroundColor:
        semanticThemeTokens.button.primary.disabled.backgroundColor,
      color: semanticThemeTokens.button.primary.disabled.textColor
    }
  }
};

export const buttonSecondary = {
  backgroundColor: semanticThemeTokens.button.secondary.default.backgroundColor,
  color: semanticThemeTokens.button.secondary.textColor,
  borderColor: semanticThemeTokens.button.secondary.default.borderColor,
  outline: "none",
  selectors: {
    "&:hover": {
      backgroundColor:
        semanticThemeTokens.button.secondary.hover.backgroundColor,
      borderColor: "transparent"
    },
    "&:active": {
      backgroundColor:
        semanticThemeTokens.button.secondary.active.backgroundColor
    },
    "&:disabled": {
      backgroundColor:
        semanticThemeTokens.button.secondary.disabled.backgroundColor,
      color: semanticThemeTokens.button.secondary.disabled.textColor,
      borderColor: semanticThemeTokens.button.secondary.disabled.borderColor
    },
    '&[aria-busy="true"]:not([disabled])': {
      backgroundColor:
        semanticThemeTokens.button.secondary.loading.backgroundColor
    }
  }
};

export const buttonTertiary = {
  backgroundColor: "transparent",
  color: semanticThemeTokens.button.tertiary.textColor,
  outline: "none",
  selectors: {
    "&:hover": {
      backgroundColor: semanticThemeTokens.button.tertiary.hover.backgroundColor
    },
    "&:active": {
      backgroundColor:
        semanticThemeTokens.button.tertiary.active.backgroundColor
    },
    "&:disabled": {
      color: semanticThemeTokens.button.tertiary.disabled.textColor
    },
    '&[aria-busy="true"]:not([disabled])': {
      backgroundColor:
        semanticThemeTokens.button.tertiary.loading.backgroundColor
    }
  }
};

export const buttonVariants = styleVariants({
  primary: buttonPrimary,
  secondary: buttonSecondary,
  tertiary: buttonTertiary
});

export const content = style({
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  selectors: {
    '&[data-hidden="true"]': { visibility: "hidden" }
  }
});

export const spinnerOverlay = style({
  position: "absolute",
  inset: 0,
  display: "grid",
  placeItems: "center",
  pointerEvents: "none"
});
